import moment from 'moment';
import { Reducer } from 'redux';
import {
  Types,
  IFabricationOrdersState,
  IFabricationOrder,
  IDownloadNFEResponse
} from './types';

const INITIAL_STATE: IFabricationOrdersState = {
  selectedContractNumbers: [],
  selectedStartDate: moment().subtract(180, 'days'),
  selectedEndDate: moment(),

  loading: false,
  error: false
};

type TCustomAction = {
  type: Types;
  payload: {
    selectedContractNumbers: string[];
    startDate: moment.Moment;
    endDate: moment.Moment;
    fabricationOrders: IFabricationOrder[];
    selectedOrder: IFabricationOrder;
    fabricationOrderId: number;
    deliveryId: number;
    downloadNFEResponse: IDownloadNFEResponse;
    contractError: boolean;
  };
};

const reducer: Reducer<IFabricationOrdersState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_FABRICATION_ORDERS:
      return {
        selectedContractNumbers: action.payload.selectedContractNumbers,
        selectedStartDate: action.payload.startDate,
        selectedEndDate: action.payload.endDate,
        loading: true,
        error: false,
        fabricationOrders: undefined
      };

    case Types.LOAD_FABRICATION_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        fabricationOrders: action.payload.fabricationOrders
      };

    case Types.LOAD_FABRICATION_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        contractError: action.payload.contractError,
        fabricationOrders: []
      };

    case Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS:
      return {
        ...state,
        fabricationOrders: setNFStateInDelivery(
          state.fabricationOrders || [],
          action.payload.fabricationOrderId,
          action.payload.deliveryId,
          true,
          false
        )
      };

    case Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS_SUCCESS:
      return {
        ...state,
        fabricationOrders: setNFStateInDelivery(
          state.fabricationOrders || [],
          action.payload.fabricationOrderId,
          action.payload.deliveryId,
          false,
          false,
          action.payload.downloadNFEResponse
        )
      };

    case Types.LOAD_NF_FILE_FROM_FABRICATION_ORDERS_FAILURE:
      return {
        ...state,
        fabricationOrders: setNFStateInDelivery(
          state.fabricationOrders || [],
          action.payload.fabricationOrderId,
          action.payload.deliveryId,
          false,
          true
        )
      };

    case Types.LOAD_FABRICATION_ORDERS_BY_ID:
      return {
        ...state,
        selectedOrder: {
          loading: true,
          error: false
        }
      };

    case Types.LOAD_FABRICATION_ORDERS_BY_ID_SUCCESS:
      return {
        ...state,
        selectedOrder: {
          order: action.payload.selectedOrder,
          loading: false,
          error: false
        }
      };

    case Types.LOAD_FABRICATION_ORDERS_BY_ID_FAILURE:
      return {
        ...state,
        order: {
          loading: false,
          error: true
        }
      };

    case Types.DOWNLOAD_NF_FILE_FROM_FABRICATION_ORDERS:
      return {
        ...state,
        fabricationOrders: setNFStateInDelivery(
          state.fabricationOrders || [],
          action.payload.fabricationOrderId,
          action.payload.deliveryId,
          false,
          false,
          action.payload.downloadNFEResponse,
          true
        )
      };

    case Types.CLEAR_FABRICATION_ORDERS_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
};

const setNFStateInDelivery = (
  items: IFabricationOrder[],
  selectedOrderId: number,
  deliveryId: number,
  loading: boolean,
  error: boolean,
  downloadNFEResponse?: IDownloadNFEResponse,
  alreadyDownloaded?: boolean
): IFabricationOrder[] => {
  const selectedItemIdx = items.findIndex(
    (item) => item.id === selectedOrderId
  );

  if (selectedItemIdx !== -1) {
    const selectedDeliveryIdx = items[selectedItemIdx].deliveries.findIndex(
      (delivery) => delivery.deliveryId === deliveryId
    );

    if (selectedDeliveryIdx !== -1) {
      items[selectedItemIdx].deliveries[selectedDeliveryIdx].nfState = {
        ...items[selectedItemIdx].deliveries[selectedDeliveryIdx].nfState,
        loading: loading,
        error: error,
        downloadNFEResponse,
        alreadyDownloaded
      };
    }
  }
  return items;
};

export default reducer;
